import React, { Component } from 'react'
import { Box, Button, Card, Grid, LinearProgress, Tooltip, Typography, IconButton, Dialog, DialogTitle, DialogActions, DialogContent, Input } from '@mui/material';
import { ListItem } from 'react-bootstrap/lib/Media';
import SFBarChart from '../../SFCharts/Bar/SFBarChart';
import SFTable from '../../../SFComponents/SFTable/SFTable';
import { PiCaretCircleUp, PiCaretCircleDown } from "react-icons/pi";
import ApiRequestService from '../../../../components/ApiRequestService';
import { IoTimerSharp } from "react-icons/io5";
import { TbTargetArrow } from "react-icons/tb";
import LoadingSpinner from '../../../../components/LoadingSpinner';
import moment from 'moment';
import { MdDelete, MdEdit } from "react-icons/md";
import { toast } from 'react-toastify';
import Toggle from 'react-toggle';
import "react-toggle/style.css";
import { IoInformationCircle } from "react-icons/io5";
import { specialCharacterValidation } from '../../../../common/functions';

export default class SFMySetDetail extends Component {

    constructor(props) {
        super(props);

        this.state = {
            assignments: [],
            categories: [],
            selectedAssignment: null,
            selectedCatIndex: 0,
            loading: false,
            showDeleteDialog: false,
            deleteAssignment: null,
            showChangeNameDialog: false,
            newPracticeSetName: "",
            columns: [
                {
                    id: 'expand',
                    name: 'Expand',
                    width: "50px",
                    visible: false,
                },
                {
                    id: 'name',
                    name: 'Category Name',
                    width: "300px",
                },
                {
                    id: 'accuracy',
                    name: 'Accuracy %',
                    width: "200px",
                },
                {
                    id: 'time',
                    name: 'Total Time',
                    width: "200px",
                },
                /* {
                    id: 'actions',
                    name: 'Actions',
                    width: "180px",
                }, */
            ],


        }

    }

    componentDidMount() {
        this.setState({
            loading: true
        })
        this.getByAssignments()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedCourse !== this.props.selectedCourse
            || prevProps.selectedStudentUserName !== this.props.selectedStudentUserName) {
            this.setState({
                loading: true
            })
            this.getByAssignments();
        }
    }

    getByAssignments = () => {
        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/getByAssignments",
            data: {
                tabIndex: 2,
                courseID: this.props.selectedCourse.course_id,
                userName: this.props.selectedStudentUserName
            }
        });

        responsePromise
            .then((res) => {
                let count = 0;
                if (res && res.data && res.data.data) {
                    console.debug("res.data.data>>>", res.data.data)
                    this.setState({
                        assignments: res.data.data,
                    })
                    count = res.data.data.length;
                    if (res.data.data && res.data.data.length) {
                        let assignments = res.data.data;
                        let selectedAssignment = res.data.data[0];
                        if (this.props.activeQuizID && this.props.activeQuizID > 0) {
                            if (assignments && assignments.length) {
                                selectedAssignment = assignments.find(assign => assign.quizID === this.props.activeQuizID);
                            }
                        }
                        console.debug("this.props.activeQuizID", this.props.activeQuizID, selectedAssignment)

                        let cats = [];
                        if (selectedAssignment && selectedAssignment.categoryDataArr) {
                            selectedAssignment.categoryDataArr.forEach(cat => {
                                cats.push({
                                    ...cat,
                                    expand: this.props.activeQuizID ? true : false,
                                })
                            })
                        }

                        if (!this.props.activeQuizID && cats && cats.length) {
                            cats[0].expand = true;
                        }

                        this.setState({
                            selectedAssignment: selectedAssignment,
                            categories: cats
                        })
                    }
                } else {
                    count = 0;
                }

                this.props.handleUpdateCount(count);
            })
            .catch((error) => {
                console.error("Error when getting Student Dashboard Data", error);
            })
            .finally(() => {
                this.setState({
                    loading: false
                })
            });
    }

    fetchStudentAssignments = () => {
        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/getStudentDashboardAssignments",
            data: {
                course_id: -1,
                tabName: "byassignments"
            }
        });
        responsePromise
            .then((res) => {
                if (res && res.data && res.data.data) {
                    console.debug("res.data.data", res.data.data)
                    this.setState({
                        assignments: res.data.data,
                        selectedAssignment: res.data.data[0]
                    })
                }
            })
            .catch((error) => {
                console.error("Error when getting Student Dashboard Data", error);
            })
            .finally(() => {

            });
    };


    handleDeleteSet = () => {
        if (this.state.deleteAssignment === null) return;
        let responsePromise = ApiRequestService({
            method: "POST",
            url: "/deleteSet",
            data: {
                quizID: this.state.deleteAssignment.quizID
            }
        });
        responsePromise
            .then((res) => {
                if (res && res.data && res.data.data) {
                    let filteredAssignments = this.state.assignments.filter(assing => assing.quizID !== this.state.deleteAssignment.quizID);
                    this.setState({
                        assignments: filteredAssignments,
                    })
                    toast.success('The practice set was deleted successfully.', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        pauseOnFocusLoss: false,
                        theme: "light",
                    });
                    if (filteredAssignments && filteredAssignments.length) {
                        this.setState({
                            selectedAssignment: filteredAssignments[0],
                            categories: filteredAssignments[0]?.categoryDataArr
                        })
                    }
                    this.props.handleUpdateCount(filteredAssignments ? filteredAssignments.length : 0);
                }
            })
            .catch((error) => {
                console.error("Error when deleting set", error);
            })
            .finally(() => {
                this.setState({
                    showDeleteDialog: false,
                    deleteAssignment: null,
                })
            });
    };

    // Get all completed assignments by student and enrolled courses

    handleExpand = (index) => {
        let value = this.state.categories[index].expand !== undefined ? !this.state.categories[index].expand : true;
        let updatedData = {
            ...this.state.categories[index],
            expand: value,
        }
        let updatedCategories = [...this.state.categories];
        updatedCategories[index] = updatedData;

        console.debug("updatedCategories", updatedCategories, updatedData)

        this.setState({
            categories: updatedCategories
        })

        const activityPayload = {
            toNomenclatureID: value ? 1 : 2,
            quizID: this.state.selectedAssignment.quizID,
            subjectID: updatedData.subjectID,
            topicID: updatedData.topicID,
            categoryID: updatedData.categoryID,
            activityTypeID: 14, // "Category"
        }
        if (this.props.onAddActivityLog) {
            this.props.onAddActivityLog(activityPayload);
        }
    }

    handleAddToPractice = (catData, index) => {
        console.debug("catData>>>", catData);
        this.props.handleSelectCategory(catData);
    }

    handleRemovFromPractice = (catData, index) => {
        console.debug("catData>>>", catData);
        this.props.handleRemoveCategory(catData);
    }

    handleStartAssignment = (assignment) => {
        let url = `/takequiz?quiz_id=${assignment.quizID || assignment.quiz_id}&course_id=${assignment.courseID || assignment.course_id}&section_id=${assignment.sectionID || assignment.section_Id}&quiz_name=${assignment.quizName || assignment.quiz_name}&quiz_type=${assignment.quiz_type}`;

        const activityPayload = {
            toNomenclatureID: 0, // clicked
            quizID: assignment.quizID,
            subjectID: 0,
            topicID: 0,
            categoryID: 0,
            activityTypeID: 22, // "Start Practice"
        }
        if (this.props.onAddActivityLog) {
            this.props.onAddActivityLog(activityPayload);
        }

        this.props.handleRoute(url)
    }

    handleToggle = (index, value) => {
        let updatedData = {
            ...this.state.categories[index],
            current: value,
        }
        let updatedCategories = [...this.state.categories];
        updatedCategories[index] = updatedData;

        this.setState({
            categories: updatedCategories
        })

        const activityPayload = {
            toNomenclatureID: value ? 4 : 3, // 4 - History, 3 - Current
            quizID: this.state.selectedAssignment.quizID,
            subjectID: updatedData.subjectID,
            topicID: updatedData.topicID,
            categoryID: updatedData.categoryID,
            activityTypeID: 26, // Toggle
        }
        if (this.props.onAddActivityLog) {
            this.props.onAddActivityLog(activityPayload);
        }
    }

    renderRow(data, index) {
        console.debug("data.categoryPracticeDataArr", data)

        function getReadableTime(timeInSec) {
            if (timeInSec <= 60) {
                return `${timeInSec} sec`
            }
            let min = moment.duration(timeInSec, 'seconds').minutes()
            let sec = moment.duration(timeInSec, 'seconds').seconds()

            return `${min}m ${sec}s`
        }

        let firstAccuracy = 0;
        let firstTimeInSec = 0;

        if (data && data.categoryPracticeDataArr && data.categoryPracticeDataArr.length) {
            let firstAttempt = data.categoryPracticeDataArr[0]
            firstAccuracy = firstAttempt.accuracyPercent;
            firstTimeInSec = firstAttempt.time;
        }

        /* let catKey = `${data.subjectID}_${data.topicID}_${data.categoryID}`
        let catIsAlreadyAdded = false;
        if (this.selectedCategories && this.selectedCategories.length) {
            this.selectedCategories.forEach(selectedCat => {
                if (`${selectedCat.subjectID}_${selectedCat.topicID}_${selectedCat.categoryID}` === catKey) {
                    catIsAlreadyAdded = true;
                }
            });
        } */

        let isCurrent = false;
        if (data.current === undefined || data.current) {
            isCurrent = true;
        }

        console.debug("isCurrent>>>>", isCurrent, data.current)

        let categoryDataArr = data.categoryPracticeDataArr;
        if (!isCurrent) {
            categoryDataArr = data.categoryPracticeDataAcrossArr;
        }

        return (
            <div>
                <div className='sf-table-row cursor-pointer'
                    onClick={() => {
                        this.handleExpand(index)
                    }}>
                    <div className='sf-table-row-div' style={{ width: '50px' }}>
                        <IconButton
                        // onClick={() => {
                        //     this.handleExpand(index)
                        // }}
                        >
                            {data.expand ?
                                <PiCaretCircleDown fontSize={24} color='#333' />
                                : <PiCaretCircleUp fontSize={24} color='#333' />}

                        </IconButton>
                    </div>
                    <div className='sf-table-row-div' style={{ width: '300px', justifyContent: "start" }}>
                        {data.name}
                    </div>
                    <div className='sf-table-row-div' style={{ width: '200px' }}>
                        <div className='w-100 h-100 text-align-center'>
                            <div>{firstAccuracy}%</div>
                            <div>
                                <LinearProgress
                                    style={{ height: '8px', borderRadius: '75px' }}
                                    variant="determinate" value={firstAccuracy} />
                            </div>
                        </div>
                    </div>
                    <div className='sf-table-row-div' style={{ width: '200px' }}>
                        <div className='text-center' style={{ color: '#0F7C27' }}>
                            <div className='fontClass-22'>
                                {getReadableTime(firstTimeInSec)}
                                {/* {data.masteryTime.toFixed(1)} */}
                                {/* {moment.duration(data.masteryTime, 'seconds').seconds()} */}

                            </div>
                            <div>{data.speed_message}</div>
                        </div>
                    </div>
                    {/* <div className='sf-table-row-div' style={{ width: '180px' }}>
                        {catIsAlreadyAdded ? <Button variant='outlined'
                        onClick={() => {
                            this.handleRemovFromPractice(data, index)
                        }}
                        >
                            Remove from Practice Set
                        </Button> :
                            <Button variant='outlined' onClick={() => {
                                this.handleAddToPractice(data, index)
                            }}>Add to Practice Set</Button>
                        }
                    </div> */}
                </div>

                <div style={{
                    display: data.expand ? "block" : 'none'
                }}>
                    {/* {data.categoryPracticeDataArr === null ? : } */}
                    <Box style={{
                        height: '400px',
                        width: '100%',
                        background: 'white',
                        gap: "2rem",
                    }} className="d-flex flex-column justify-content-center align-items-center">

                        <div className='d-flex justify-content-center align-items-center mt-3'>
                            <Tooltip title={
                                <Typography fontSize={12} color='#fff'>
                                    Current assignment/set data
                                </Typography>
                            } placement="top" arrow>

                                <Typography fontSize={14}
                                    fontWeight={isCurrent ? 800 : 500}
                                >
                                    <IoInformationCircle fontSize={16} color='#646a6e' /> Current
                                </Typography>
                            </Tooltip>
                            <Toggle
                                id="accuracy_or_time"
                                icons={false}
                                className="mx-3"
                                checked={!isCurrent}
                                onChange={() => {
                                    this.handleToggle(index, !isCurrent)
                                }}
                            />
                            <Tooltip title={
                                <Typography fontSize={12} color='#fff'>
                                    Data across all assignments/sets
                                </Typography>
                            } placement="top" arrow>
                                <Typography fontSize={14}
                                    fontWeight={!isCurrent ? 800 : 500}
                                >
                                    History <IoInformationCircle fontSize={16} color='#646a6e' />
                                </Typography>
                            </Tooltip>
                        </div>
                        <div className="d-flex justify-content-center align-items-center h-100 w-100" style={{
                            marginTop: "-8px",
                            gap: "2rem",
                        }}>
                            <SFBarChart
                                title={
                                    <div className='pl-5'>
                                        <center>
                                            <Typography fontSize={14} fontWeight={600}>
                                                <TbTargetArrow fontSize={22} /> Accuracy %
                                            </Typography>
                                        </center>
                                    </div>
                                }
                                format="%"
                                type={"linear"}
                                xAxisLabel={"Attempts #"}
                                yAxisLabel={"Accuracy %"}
                                isPractice={isCurrent}
                                labels={categoryDataArr ? categoryDataArr.map((_, index) => index + 1) : []}
                                dataArr={categoryDataArr ? categoryDataArr?.map(cat => cat.accuracyPercent) : []}
                                practiceDataArr={categoryDataArr ? categoryDataArr?.map(cat => cat.accuracyGoal) : []}
                                min={0}
                                max={100}
                                stepSize={20}
                            />
                            <SFBarChart
                                title={
                                    <div className='pl-5'>
                                        <center>
                                            <Typography fontSize={14} fontWeight={600}>
                                                <IoTimerSharp fontSize={22} /> Time Taken (min)
                                            </Typography>
                                        </center>
                                    </div>
                                }
                                format="m"
                                type={"logarithmic"}
                                xAxisLabel={"Attempts #"}
                                yAxisLabel={"Time Take (min)"}
                                isPractice={isCurrent}
                                labels={categoryDataArr ? categoryDataArr?.map((_, index) => index + 1) : []}
                                dataArr={categoryDataArr ? categoryDataArr?.map(cat => {
                                    return parseFloat((cat.time / 60).toFixed(1))
                                }) : []}
                                practiceDataArr={categoryDataArr ? categoryDataArr?.map(cat => {
                                    return cat.timeGoal
                                }) : []}
                                min={0}
                                max={10}
                                stepSize={1}
                            />
                        </div>
                    </Box>
                </div>

                <div className='justify-content-center align-items-center pb-4 pt-3' style={{
                    gap: "2rem",
                    display: data.expand ? "flex" : 'none',
                    background: "#fff",
                }}>
                    {/* <div className='d-flex justify-content-center align-items-center' style={{
                        gap: "6px"
                    }}>
                        <div style={{ background: "#0077B9", width: "30px", height: "7px" }}></div>
                        Graded
                    </div> */}
                    <div className='d-flex justify-content-center align-items-center' style={{
                        gap: "6px"
                    }}>
                        <div style={{ background: "#FF5287", width: "30px", height: "7px" }}></div>
                        Practice
                    </div>
                    <div className='d-flex justify-content-center align-items-center' style={{
                        gap: "6px"
                    }}>
                        <div style={{ background: "#D6AAAC", width: "30px", height: "7px", borderRadius: "15px" }}></div>
                        Goal
                    </div>
                </div>

            </div>
        )
    }

    updatePracticeSet = () => {
        /* if (specialCharacterValidation(this.state.newPracticeSetName)) {
            toast.error('Assignment Name cannot contain( /, \\, * , : , comma ,@ , & , % , $ , # , !)', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                pauseOnFocusLoss: false,
                theme: "light",
            });
            return;
        } */
        console.debug("this.state.selectedAssignment", this.state.selectedAssignment)
        let payload = {
            quizID: this.state.selectedAssignment.quizID,
            quizName: this.state.newPracticeSetName,
        }

        if (payload.quizID && payload.quizName) {
            let responsePromise = ApiRequestService({
                method: "POST",
                url: "/updateSet",
                data: payload
            });
            responsePromise
                .then((res) => {
                    if (res && res.data && res.data.data) {
                        toast.success('Updated practice set name', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            pauseOnFocusLoss: false,
                            theme: "light",
                        });
                        let updatedSelectedAssignment = null
                        let updatedAssignments = this.state.assignments.map(assign => {
                            let quizName = assign.quizName;
                            if (assign.quizID === payload.quizID) {
                                quizName = payload.quizName;
                                updatedSelectedAssignment = {
                                    ...assign,
                                    quizName: payload.quizName,
                                };
                            }
                            return {
                                ...assign,
                                quizName: quizName,
                            }
                        })
                        this.setState({
                            assignments: updatedAssignments,
                            selectedAssignment: updatedSelectedAssignment
                        })

                    }
                })
                .catch((error) => {
                    console.error("Error when updating set name", error);
                })
                .finally(() => {
                    this.setState({
                        showChangeNameDialog: false,
                        newPracticeSetName: "",
                    })
                });
        } else {
            toast.error("Practice set name is empty")
        }
    }


    render() {

        const { assignments, selectedAssignment, loading } = this.state;

        if (loading) {
            return (
                <div className='sf-fixed-center'>
                    <LoadingSpinner loading={true} />
                </div>
            )
        }

        if (assignments && assignments.length === 0) {
            return (
                <div className='sf-fixed-center'>
                    <Typography fontSize={24} fontWeight={500}>
                        No Data Found.
                    </Typography>
                </div>
            )
        }

        return (
            <Grid container spacing={2} className='sf-pa-gird'>
                <Grid item md={2}
                    className='sf-assig-list p-0 mt-3 pl-4'
                >
                    <Card className='pr-3 pr-2 h-100 overflow-auto'>
                        <Typography className='py-2' textAlign={'center'} fontSize={16} fontWeight={700}>
                            Practice Set Name
                        </Typography>
                        {assignments.map((assign, index) => {
                            return (
                                <div className='d-flex justify-content-end'>
                                    <ListItem key={index} className={`
                                    ${selectedAssignment?.quizID === assign.quizID ? "pa-assignment-selected " : " "}

                                    pa-assignment mb-1 w-100
                                `}
                                        onClick={() => {
                                            let categories = assign.categoryDataArr;
                                            if (categories && categories.length) {
                                                categories[0].expand = true;
                                            }
                                            this.setState({
                                                selectedAssignment: assign,
                                                categories: categories
                                            })

                                            let logPayload = {
                                                toNomenclatureID: 0, // clicked
                                                quizID: assign.quizID,
                                                subjectID: assign.subjectID,
                                                topicID: assign.topicID,
                                                categoryID: 0,
                                                activityTypeID: 19, // "Assignment" activity in p&p page
                                            };

                                            if (this.props.onAddActivityLog) {
                                                this.props.onAddActivityLog(logPayload);
                                            }

                                        }}
                                    >
                                        <div className='d-flex justify-content-between align-items-center w-100 pl-3'>
                                            <div>
                                                {assign.quizName}
                                            </div>
                                        </div>
                                    </ListItem>
                                    {selectedAssignment?.quizID === assign.quizID ?
                                        <div className='d-flex a1 justify-content-center align-items-center'>
                                            <Tooltip title="Edit practice set name" placement="top" arrow>
                                                <IconButton color='primary'
                                                    disabled={this.props.isInstructor}
                                                    size='small'
                                                    onClick={() => {
                                                        this.setState({
                                                            showChangeNameDialog: true,
                                                            newPracticeSetName: selectedAssignment?.quizName,
                                                        })
                                                    }}>
                                                    <MdEdit fontSize={18} />
                                                </IconButton>
                                            </Tooltip>
                                            <IconButton color='primary'
                                                disabled={this.props.isInstructor}
                                                size='small'
                                                style={{ width: '26px', height: '26px' }}
                                                onClick={() => {
                                                    this.setState({
                                                        showDeleteDialog: true,
                                                        deleteAssignment: assign,
                                                    })
                                                }}>
                                                <MdDelete fontSize={18} />
                                            </IconButton>

                                        </div>
                                        : null}
                                </div>
                            )
                        })}
                    </Card>
                </Grid>
                <Grid item
                    md={10}
                    className='sf-pa-list'>
                    <div style={{ width: "100%", height: '100%' }}>
                        <div className='d-flex justify-content-start align-items-center mb-2'
                            style={{
                                gap: '1rem'
                            }}>
                            <div className='d-flex justify-content-start align-items-center'>
                                <Typography fontSize={30} fontWeight='bold'>
                                    {selectedAssignment?.quizName}
                                </Typography>
                            </div>
                            <Button variant='contained'
                                className='ml-2'
                                disabled={this.props.isInstructor}
                                onClick={() => {
                                    this.handleStartAssignment(selectedAssignment)
                                }}
                            >
                                Start Practice Set
                            </Button>
                        </div>

                        {/* Category Table */}
                        <div className='mt-0 w-100 position-relative'
                            style={{
                                height: "calc(100% - 30px)" // - 70px
                            }}
                        >
                            <SFTable
                                columns={this.state.columns}
                                dataArr={this.state.categories || null}
                                renderRow={this.renderRow}
                                handleExpand={this.handleExpand}
                                handleToggle={this.handleToggle}
                                handleAddToPractice={this.handleAddToPractice}
                                handleRemovFromPractice={this.handleRemovFromPractice}
                                selectedCategories={this.props.selectedCategories}
                                selectedAssignment={selectedAssignment}
                            />
                        </div>

                    </div>

                </Grid>
                {/* Practice set name change dialog */}
                <Dialog open={this.state.showChangeNameDialog}
                    fullWidth
                    maxWidth='sm'
                    onClose={() => {
                        this.setState({
                            showChangeNameDialog: false,
                            newPracticeSetName: null,
                        })
                    }}
                >
                    <DialogTitle fontWeight={600}>Update Practice Set Name</DialogTitle>
                    <DialogContent>
                        <Input
                            size='medium'
                            style={{
                                width: "100%",
                                fontSize: '1.2rem'
                            }}
                            placeholder='Enter your practice set name'
                            value={this.state.newPracticeSetName}
                            onChange={(event) => {
                                this.setState({
                                    newPracticeSetName: event.target.value,
                                })
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='outlined'
                            onClick={() => {
                                this.setState({
                                    showChangeNameDialog: false,
                                    newPracticeSetName: null,
                                })
                            }}>Cancel</Button>
                        <Button
                            variant='contained'
                            disabled={this.state.newPracticeSetName === ""}
                            onClick={() => {
                                this.updatePracticeSet()
                            }} autoFocus>
                            Update
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Delete set dialog */}
                <Dialog open={this.state.showDeleteDialog}
                    fullWidth
                    maxWidth='sm'
                    onClose={() => {
                        this.setState({
                            showDeleteDialog: false,
                            deleteAssignment: null,
                        })
                    }}
                >
                    <DialogTitle fontWeight={600}>Delete My Set</DialogTitle>
                    <DialogContent>
                        <Typography fontSize={16}>
                            Are you sure you want to delete "{this.state.deleteAssignment?.quizName}"?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant='outlined'
                            onClick={() => {
                                this.setState({
                                    showDeleteDialog: false,
                                    deleteAssignment: null,
                                })
                            }}>Cancel</Button>
                        <Button
                            variant='contained'
                            onClick={() => {
                                this.handleDeleteSet();
                            }} autoFocus>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>

            </Grid>
        )
    }
}

